import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { UserPlus, Send, Lock, ChevronDown, ChevronUp } from "lucide-react";

const STATUS_PT = { contacted: "Contactei", interested: "Interessado", declined: "Não quer" };
const STATUS_COLOR = { contacted: "#3B82F6", interested: "#22C55E", declined: "#737373" };

export function RecruitPanel({ club }) {
  const [d, setD] = useState(null);
  const [vac, setVac] = useState(1);
  const [note, setNote] = useState("");
  const [preview, setPreview] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/recruit-requests?club=${encodeURIComponent(club)}`).then((r) => setD(r.data)).catch(() => setD(false));
  useEffect(() => { load(); }, [club]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const req = d.request;
  const open = req?.status === "open";

  const start = async () => {
    if (!window.confirm(`Enviar o pedido de recrutamento (${vac} vaga${vac > 1 ? "s" : ""}) a ${d.recipients} pessoas: coopetidores, Secretário e Presidente dos ${club}?`)) return;
    setBusy(true);
    try { const r = await api.post("/recruit-requests", { club, vacancies: vac, note }); toast.success(`${r.data.sent} emails enviados`); load(); }
    catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  const close = async () => {
    if (!window.confirm("Fechar o pedido de recrutamento?")) return;
    try { await api.post(`/recruit-requests/${req.id}/close`); load(); } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="kw-card p-5 space-y-3" data-testid="recruit-panel">
      <div className="flex flex-wrap items-center gap-3">
        <UserPlus className="w-5 h-5 text-[#22C55E]" />
        <span className="font-display font-black uppercase flex-1">Pedido de recrutamento</span>
        <span className="text-[10px] uppercase tracking-widest text-[#737373]">{d.eligible} elegíveis · {d.recipients} destinatários</span>
      </div>
      {req && (
        <div className="space-y-1" data-testid="recruit-status">
          <div className="text-xs text-[#A3A3A3]">
            Pedido {open ? "aberto" : "fechado"} · {req.filled}/{req.vacancies} vaga(s) preenchida(s) · {req.contacts.length} contacto(s) registados
          </div>
          {req.contacts.slice(0, 12).map((c, i) => (
            <div key={i} className="flex items-center gap-2 text-xs">
              <span className="flex-1 truncate">{c.candidate_name}</span>
              <span className="text-[#737373] truncate">por {c.recruiter_name}</span>
              <span className="font-bold uppercase text-[10px]" style={{ color: STATUS_COLOR[c.status] }}>{STATUS_PT[c.status]}</span>
            </div>
          ))}
        </div>
      )}
      {open ? (
        <button onClick={close} className="kw-btn-secondary !py-1.5 text-[10px] inline-flex items-center gap-1" data-testid="recruit-close">
          <Lock className="w-3 h-3" /> Fechar pedido
        </button>
      ) : (
        <div className="flex flex-wrap items-end gap-2">
          <label className="text-[10px] uppercase tracking-widest text-[#737373]">Vagas
            <input type="number" min="1" max="8" value={vac} onChange={(e) => setVac(Number(e.target.value) || 1)}
              className="kw-input !py-1.5 !w-20 block mt-1" data-testid="recruit-vacancies" />
          </label>
          <input className="kw-input !py-1.5 flex-1 min-w-[200px] text-xs" placeholder="Nota opcional para o email (ex.: prazo, perfil que procuramos)"
            value={note} onChange={(e) => setNote(e.target.value)} data-testid="recruit-note" />
          <button onClick={() => setPreview(!preview)} className="kw-btn-secondary !py-1.5 text-[10px] inline-flex items-center gap-1"
            data-testid="recruit-preview-toggle">{preview ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />} Ver email</button>
          <button onClick={start} disabled={busy || !d.eligible} className="kw-btn-primary !py-1.5 text-[10px] inline-flex items-center gap-1"
            data-testid="recruit-start"><Send className="w-3 h-3" /> Pedir recrutamento</button>
        </div>
      )}
      {preview && !open && (
        <div className="bg-white text-black p-4 text-sm" data-testid="recruit-preview">
          <div className="text-xs text-[#555] mb-2"><b>Assunto:</b> {d.preview.subject}</div>
          <div dangerouslySetInnerHTML={{ __html: d.preview.html }} />
        </div>
      )}
    </div>
  );
}
